module.exports = __webpack_public_path__ + "static/media/Wigfrid_Portrait.dd3c91b5.png";